import React, { useEffect, useState } from 'react';
import AnnualSubscriptionModal, { AnnualUpgradeActionWrapper } from '../../../components/AnnualSubscriptionModal';
import { MediumOutlineButton } from '../../../components/Buttons';
import useModal from '../../../hooks/useModal';
import alertService from '../../../services/AlertService';
import licenseService from '../../../services/licenseService';
import { CurriculumPricing, getCurriculumPricing } from '../../curriculum';

type License = {
  item?: {
    number: string;
  };
  subscription?: Subscription;
};

type CurriculumLicense = {
  itemNumber: string;
};

type Subscription = {
  [key: string]: any;
};

type Props = {
  curriculumId: string;
  orgId?: string;
};

const findCurriculum = (crmId: string, curriculums: CurriculumPricing[]) =>
  curriculums.map(c => c.curriculum.find(({ id }: { id: string }) => id === crmId)).filter(Boolean)[0];

const getActiveCurriculumSubscription = (licenses: License[], curriculumLicenses: CurriculumLicense[]) =>
  licenses.find(license => {
    if (!curriculumLicenses.find(cl => cl.itemNumber === license.item?.number)) return false;
    if (!licenseService.isActiveSubscription(license) || !licenseService.isMonthlySubscription(license)) return false;
    return true;
  })?.subscription;

export const AnnualSubscriptionUpgradeButton = ({ curriculumId, orgId }: Props) => {
  const [subscription, setSubscription] = useState<Subscription>();

  const handleUpgradedSubscription = (newSubscription: Subscription) => {
    alertService.show('Subscription Updated');
    setSubscription(prev => ({ ...prev, ...newSubscription }));
  };

  const [modal, openModal] = useModal((type: string, payload: any, dismissModal: () => void) => {
    return type ? (
      <AnnualSubscriptionModal
        subscription={payload}
        onUpgradeComplete={handleUpgradedSubscription}
        handleDismiss={dismissModal}
      />
    ) : null;
  });

  useEffect(() => {
    if (!curriculumId || !orgId) return;

    Promise.all([licenseService.getPairedLicenses(orgId), getCurriculumPricing()]).then(([licenses, curriculums]) => {
      const curriculum = findCurriculum(curriculumId, curriculums);
      if (!curriculum) return;

      const curriculumSubscription = getActiveCurriculumSubscription(licenses, curriculum.license);
      if (!curriculumSubscription) return;

      setSubscription(curriculumSubscription);
    });
  }, []);

  return (
    <>
      <AnnualUpgradeActionWrapper subscription={subscription}>
        {annualSubscription => (
          <MediumOutlineButton onClick={() => openModal('annual', annualSubscription)}>
            <i className="fas fa-cog"></i> Switch to Annual
          </MediumOutlineButton>
        )}
      </AnnualUpgradeActionWrapper>
      {modal}
    </>
  );
};
